class SearchSort extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.details = this.querySelector("details");
    this.form = this.querySelector("form");
    this.sort = this.querySelector(".search-sort") || this; // fallback to self
    this.sortInput = this.querySelector("[data-sort-input]");
    this.searchContainer = document.querySelector("[data-product-container]");

    // Bind the handler for event delegation
    this.handleSortClick = this.handleSortClick.bind(this);
  }

  connectedCallback() {
    this.setupListeners();
    const filter = document.querySelector('.main-search__controls');
    const sentinel = document.querySelector('[data-sort-target="stick"]');
    const header = document.querySelector('.header');

    // ===== Sticky Filter Bar Logic =====
    if (filter && sentinel && header) {
      const updateStickyTop = () => {
        const isMobile = window.innerWidth < 960;
        const headerHeight = header.offsetHeight - (isMobile ? 8 : 25);
        filter.style.setProperty('--sticky-top', `${headerHeight}px`);
        return headerHeight;
      };

      let headerHeight = updateStickyTop();

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            headerHeight = updateStickyTop();
            document.body.classList.add('sort--sticking');
            filter.classList.add('clp__filter--sticky');
          } else {
            document.body.classList.remove('sort--sticking');
            filter.classList.remove('clp__filter--sticky');
          }
        },
        {
          rootMargin: `-${headerHeight}px 0px 0px 0px`,
          threshold: 0,
        }
      );

      observer.observe(sentinel);

      window.addEventListener('resize', () => {
        headerHeight = updateStickyTop();
      });
    }
  }

  setupListeners() {
    // Remove previous listener first (avoid duplicates)
    this.sort.removeEventListener("click", this.handleSortClick);
    // Add one listener on container for delegation
    this.sort.addEventListener("click", this.handleSortClick);
  }

  handleSortClick(event) {
    const button = event.target.closest("button[data-value]");
    if (!button) return;

    event.preventDefault();

    this.sortInput.value = button.dataset.value;
    this.handleSort();
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  handleSort() {
    const searchParams = this.createSearchParams(this.form);
    this.submitForm(searchParams);
  }

  submitForm(searchParams) {
    const url = new URL(window.location.href);

    // Keep existing query params except those in searchParams, then override
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    history.replaceState("", "", url);
    this.fetchCollection(url.href);
  }

  fetchCollection(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
        const newContainer = parsedHTML.querySelector("[data-product-container]");
        const newSort = parsedHTML.querySelector(".search-sort");

        if (newSort && this.sort) {
          // Replace innerHTML of the sort container only — do NOT replace the whole <search-sort> element
          this.sort.innerHTML = newSort.innerHTML;
          this.details = this.sort.querySelector("details");
          this.form = this.sort.querySelector("form");
          this.sortInput = this.sort.querySelector("[data-sort-input]");
        }

        if (newContainer && this.searchContainer) {
          this.searchContainer.innerHTML = newContainer.innerHTML;
        }

        // Update visible selected sort label in summary
        const newSummarySpan = this.sort.querySelector(".search-sort__summary .body-2");
        const selectedButton = this.sort.querySelector("button.selected");
        if (newSummarySpan && selectedButton) {
          newSummarySpan.textContent = selectedButton.textContent.trim();
        }

        const event = new CustomEvent("sort:updated", { bubbles: true });
        this.searchContainer.dispatchEvent(event);

        // Close details after sorting
        this.details?.removeAttribute("open");

        // Re-setup event listeners (important!)
        this.setupListeners();
      })
      .catch((err) => {
        console.error("Error fetching sorted collection:", err);
      });
  }
}

if (!customElements.get("search-sort")) {
  customElements.define("search-sort", SearchSort);
}